import axiosClient from './axiosClient';

export const cpdCertificatesService = {
  create: (certificate) => axiosClient.post('/cpd-certificates/', certificate),
  list: (params) => axiosClient.get('/cpd-certificates/', { params }),
  get: (id) => axiosClient.get(`/cpd-certificates/${id}/`),
  delete: (id) => axiosClient.delete(`/cpd-certificates/${id}/`),
  downloadPdf: (id) => axiosClient.get(`/cpd-certificates/${id}/pdf/`, {
    responseType: 'blob'
  }),
  generatePdf: (id) => axiosClient.post(`/cpd-certificates/${id}/generate-pdf/`)
};
